import React, { ReactNode } from 'react';
import { Flex } from '../Flex';
import { Text } from '../Text';
import { ExtendedDropdownItem } from '../GlobalInterfaces/Interfaces';

type HeaderSelector<T> = (item: T) => string;

export function toExtendedDropdownItem<T>(
  item: T,
  header: HeaderSelector<T>,
  icon?: ReactNode,
): ExtendedDropdownItem<T> {
  return {
    item,
    header: !icon && header(item),
    content: icon && {
      content: (
        <Flex
          style={{ fontSize: '0.875rem' }}
          gap="0.5rem"
          align="center"
          justify="space-between"
        >
          <Text>{header(item)}</Text>
          {icon}
        </Flex>
      ),
    },
  };
}
